<script setup lang="ts">
import { EyeIcon } from '@heroicons/vue/24/outline'
defineProps(['params'])
</script>

<template>
  <button
    v-if="params.data.errors?.length || params.data.crashMessage"
    class="btn btn-ghost btn-xs gap-1"
    title="Voir le détail des erreurs"
    @click="params.onView(params.data)"
  >
    <EyeIcon class="w-4 h-4" />
    {{ params.data.errors?.length ?? (params.data.crashMessage ? 1 : 0) }}
  </button>
  <span v-else class="text-base-content/30">—</span>
</template>
